import { TreatyType } from "_graphql/__generated__/globalTypes";
import { Colors } from "_graphql/data";
import { GetTreatyReinsurerParticipants_getTreatyReinsurerParticipants } from "_graphql/visal/queries/__generated__/GetTreatyReinsurerParticipants";
import { Treaty_treaty } from "_graphql/visal/queries/__generated__/Treaty";
import { Pie } from "components";
import _ from "lodash";

type Props = {
  treaty: Treaty_treaty | null | undefined;
  layer: string;
  reinsurers: (GetTreatyReinsurerParticipants_getTreatyReinsurerParticipants | null)[];
};

const RepresentationOfShares = ({ treaty, layer, reinsurers }: Props) => {
  const groupedItems = _.groupBy(
    treaty?.treaty_participants || [],
    "layer_number"
  );

  const totalAssignedNonProp =
    _.get(groupedItems, layer || 1, [])?.reduce(
      (acc: number, item: any) =>
        acc + (item?.treaty_participation_percentage || 0),
      0
    ) || 0;
  const totalAssignedProp =
    treaty?.treaty_participants?.reduce(
      (acc: number, item: any) =>
        acc + (item?.treaty_participation_percentage || 0),
      0
    ) || 0;

  const totalUnAssigned =
    Number(treaty?.order_hereon) -
    (treaty?.treaty_program?.treaty_type === TreatyType.NONPROPORTIONAL
      ? totalAssignedNonProp
      : totalAssignedProp);

  const list =
    treaty?.treaty_program?.treaty_type === TreatyType.NONPROPORTIONAL
      ? _.get(groupedItems, layer, [])
      : reinsurers;

  return (
    <>
      <span className="text-center text-gray-600 dark:text-gray-300 text-sm font-bold mb-4">
        Percentage Left:{totalUnAssigned}%
      </span>
      <div className="w-full max-w-[240px] h-60">
        <Pie
          data={[
            ...list?.map((el, idx) => ({
              label: el?.reinsurer?.re_company_name || "",
              value: el?.treaty_participation_percentage || 0,
              bgColor: Colors[idx],
              color: Colors[idx],
              id: el?.treaty_participation_id || "",
            })),
            {
              label: "Unassigned",
              value: totalUnAssigned,
              color: "#ccc",
              bgColor: "#ccc",
              id: "Unassigned",
            },
          ]}
          innerRadius={0.5}
        />
      </div>
    </>
  );
};

export default RepresentationOfShares;
